import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  isOffline: boolean;
}

export const useStyles = makeStyles(
  {
    root: {
      backgroundColor: 'rgba(220, 63, 83, 0.7)',
      position: 'fixed',
      bottom: 0,
      right: 0,
      left: 0,
      top: 'initial',
      textTransform: 'initial',
      width: '100%',
      padding: '10px',
      fontSize: '18px',
      color: 'white',
      textAlign: 'center',
      zIndex: 1000
    },
    green: {
      backgroundColor: 'rgba(24, 226, 58, 0.7)'
    }
  },
  { name: 'internetStatus' }
);

export const InternetStatus: React.FC<IProps> = props => {
  const [isOffline, setIsOffline] = useState(false);
  const [prevStateOffline, setPrevStateOffline] = useState(false);
  const [showOnline, setShowOnline] = useState(false);

  const styles = useStyles({});

  const checkPrevState = useCallback(() => {
    if (prevStateOffline === true && !props.isOffline) {
      setShowOnline(true);
      setTimeout(() => setShowOnline(false), 2000);
    }
    setPrevStateOffline(props.isOffline);
  }, [props.isOffline, prevStateOffline]);

  useEffect(() => {
    checkPrevState();
    setIsOffline(props.isOffline);
  }, [props.isOffline, checkPrevState]);
  if (!isOffline && !showOnline) {
    return null;
  }

  if (showOnline) {
    return <div className={`${styles.root} ${styles.green}`}>Reconectado</div>;
  }

  return <div className={styles.root}>Parece que você está sem internet, verifique sua conexão</div>;
};

export default InternetStatus;
